module.exports = __webpack_public_path__ + "media/images/ohap__Arrow_White_Up_Down-6886a918971867338427892ba4b06309.png";